import { useLanguage } from '@languages/index';

const OUTPUT_TYPES = {
  PHOTO: 1,
  VIDEOS: 2,
};

const TYPES = {
  OUTPUT: 1,
  GUIDE: 2,
  PROHIBITIONS: 3,
  PROHIBITIONS_BEAUTY: 7,
  TEXTS: 4,
  SELECTIONS: 5,
  REQUIREMENTS: 6,
  BRAND_LOGO: 8,
  ATTACHMENT: 9,
  EMBLEM: 11,
};

const GROUP_NAMES = {
  REELS_REQUESTS: 'REELS_REQUESTS',
  REELS_REFERENCE: 'REELS_REFERENCE',
  REELS_REFERENCE_DESCRIPTION: 'REELS_REFERENCE_DESCRIPTION',
  OTHER_REQUESTS: 'OTHER_REQUESTS',
  MANDATORY_PHRASE: 'MANDATORY_PHRASE',
  PROHIBITIONS: 'PROHIBITIONS',
  PROHIBITIONS_BEAUTY: 'PROHIBITIONS_BEAUTY',
  REQUIREMENTS: 'REQUIREMENTS',
  HASH_TAG_LOCATION: 'HASH_TAG_LOCATION',
  ALLOW_OTHER_AT_TAG: 'ALLOW_OTHER_AT_TAG',
  ALLOW_ADVERTISEMENT_TAG: 'ALLOW_ADVERTISEMENT_TAG',
  GUIDE_IMAGE: 'GUIDE_IMAGE',
  AT_TAGS: 'AT_TAGS',
  HASH_TAGS: 'HASH_TAGS',
  PHOTO_MODEL_FULL: 'PHOTO_MODEL_FULL',
  PHOTO_MODEL_HALF: 'PHOTO_MODEL_HALF',
  PHOTO_MODEL_CLOSEUP: 'PHOTO_MODEL_CLOSEUP',
  PHOTO_MODEL_WITHOUT_FACE: 'PHOTO_MODEL_WITHOUT_FACE',
  PHOTO_PRODUCT_FULL: 'PHOTO_PRODUCT_FULL',
  PHOTO_PRODUCT_CLOSEUP: 'PHOTO_PRODUCT_CLOSEUP',
  REELS_BEAUTY_PRODUCT_SELFIE: 'REELS_BEAUTY_PRODUCT_SELFIE',
  REELS_BEAUTY_PRODUCT_TRY: 'REELS_BEAUTY_PRODUCT_TRY',
  REELS_BEAUTY_PRODUCT_FULL: 'REELS_BEAUTY_PRODUCT_FULL',
  REELS_PRODUCT: 'REELS_PRODUCT',
  REELS_PRODUCT_PACKAGE: 'REELS_PRODUCT_PACKAGE',
  REELS_PRODUCT_TEXTURE: 'REELS_PRODUCT_TEXTURE',
  REELS_PRODUCT_COLOR: 'REELS_PRODUCT_COLOR',
  REELS_PRODUCT_TRY: 'REELS_PRODUCT_TRY',
  REELS_PRODUCT_BEFORE_AFTER: 'REELS_PRODUCT_BEFORE_AFTER',
  REELS_PRODUCT_SELFIE: 'REELS_PRODUCT_SELFIE',
  SUBTITLE_OPENING: 'SUBTITLE_OPENING',
  SUBTITLE_MIDDLE: 'SUBTITLE_MIDDLE',
  SUBTITLE_CLOSING: 'SUBTITLE_CLOSING',
  CONTENT: 'CONTENT',
  VIDEO_DURATION: 'VIDEO_DURATION',
  CO_AUTHOR: 'CO_AUTHOR',
  PREFERRED_VIDEO_TYPE: 'PREFERRED_VIDEO_TYPE',
  BRAND_LOGO: 'BRAND_LOGO',
  REQUIRE_PARTNERSHIP_CODE: 'REQUIRE_PARTNERSHIP_CODE',
  ATTACHMENT_RAW_VIDEO: 'ATTACHMENT_RAW_VIDEO',
  EMBLEM_OLIVEYOUNG: 'EMBLEM_OLIVEYOUNG',
  INSPECTION_FEEDBACK_SEQUENCE: 'INSPECTION_FEEDBACK_SEQUENCE',
  SUBTITLE_FONT: 'SUBTITLE_FONT',
  SUBTITLE_SIZE: 'SUBTITLE_SIZE',
  BACKGROUND_MUSIC_EDIT: 'BACKGROUND_MUSIC_EDIT',
  NARRATION_ADD: 'NARRATION_ADD',
  NARRATION_EDIT: 'NARRATION_EDIT',
};

const OPTIONS_PROHIBITIONS = {
  OTHER_PEOPLE: 'OTHER_PEOPLE',
  MIRROR_SELFIE: 'MIRROR_SELFIE',
  MASK: 'MASK',
  INDOORS: 'INDOORS',
  PLACE_ROOFTOP: 'PLACE_ROOFTOP',
};

const OPTIONS_PROHIBITIONS_BEAUTY = {
  GRWM_AND_OTHER_PRODUCTS: 'GRWM_AND_OTHER_PRODUCTS',
  MAKE_UP: 'MAKE_UP',
  TPO_MISMATCH: 'TPO_MISMATCH',
  FINGERPRINTS: 'FINGERPRINTS',
  ENLARGE: 'ENLARGE',
  SLIDESHOW: 'SLIDESHOW',
  COMMERCIAL_CONTENTS: 'COMMERCIAL_CONTENTS',
  HDR: 'HDR',
  DEADZONE: 'DEADZONE',
};

const OPTIONS_REQUIREMENTS = {
  IRONING: 'IRONING',
  VIDEO_CLEAN: 'VIDEO_CLEAN',
};

const OPTIONS_HASH_TAG_LOCATION = {
  POST: 'POST',
  COMMENT: 'COMMENT',
};

const OPTIONS_ALLOW_OTHER_AT_TAG = {
  ALLOW: 'ALLOW',
  DISALLOW: 'DISALLOW',
};

const OPTIONS_ALLOW_ADVERTISEMENT_TAG = {
  ALLOW: 'ALLOW',
  DISALLOW: 'DISALLOW',
};

const OPTIONS_VIDEO_DURATION = {
  TWOWENTY: 'TWOWENTY',
  THIRTY: 'THIRTY',
};

const OPTIONS_PREFERRED_VIDEO_TYPE = {
  EMOTIONAL: 'EMOTIONAL',
  INFOMATIVE: 'INFOMATIVE',
  VISITING: 'VISITING',
  OY_VISITING: 'OY_VISITING',
  OY_PRODUCT_ONLY: 'OY_PRODUCT_ONLY',
};

const RESERVED_FEEDBACK_TEXT = {
  VIOLATED: 'VIOLATED',
  NOT_INCLUDED: 'NOT_INCLUDED',
};

const OPTIONS_REQUIRE_PARTNERSHIP_CODE = {
  REQUIRED: 'REQUIRED',
  NOT_REQUIRED: 'NOT_REQUIRED',
};

export const GetOptionTranslationMap = (groupName: string, value?: string) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.constants.OPTION_TRANSLATION_MAP,
  };

  // 옵션이 있는 그룹들
  // prettier-ignore
  const OPTION_GROUP_MAP = {
    [GROUP_NAMES.PROHIBITIONS]: {
      [OPTIONS_PROHIBITIONS.MASK]: languageTexts.PROHIBITIONS_MASK,
      [OPTIONS_PROHIBITIONS.MIRROR_SELFIE]: languageTexts.PROHIBITIONS_MIRROR_SELFIE,
      [OPTIONS_PROHIBITIONS.OTHER_PEOPLE]: languageTexts.PROHIBITIONS_OTHER_PEOPLE,
      [OPTIONS_PROHIBITIONS.INDOORS]: languageTexts.PROHIBITIONS_INDOORS,
      [OPTIONS_PROHIBITIONS.PLACE_ROOFTOP]: languageTexts.PROHIBITIONS_PLACE_ROOFTOP,
    },
    [GROUP_NAMES.PROHIBITIONS_BEAUTY]: {
      [OPTIONS_PROHIBITIONS_BEAUTY.GRWM_AND_OTHER_PRODUCTS]: languageTexts.PROHIBITIONS_BEAUTY_GRWM_AND_OTHER_PRODUCTS,
      [OPTIONS_PROHIBITIONS_BEAUTY.MAKE_UP]: languageTexts.PROHIBITIONS_BEAUTY_MAKE_UP,
      [OPTIONS_PROHIBITIONS_BEAUTY.TPO_MISMATCH]: languageTexts.PROHIBITIONS_BEAUTY_TPO_MISMATCH,
      [OPTIONS_PROHIBITIONS_BEAUTY.FINGERPRINTS]: languageTexts.PROHIBITIONS_BEAUTY_FINGERPRINTS,
      [OPTIONS_PROHIBITIONS_BEAUTY.ENLARGE]: languageTexts.PROHIBITIONS_BEAUTY_ENLARGE,
      [OPTIONS_PROHIBITIONS_BEAUTY.SLIDESHOW]: languageTexts.PROHIBITIONS_BEAUTY_SLIDESHOW,
      [OPTIONS_PROHIBITIONS_BEAUTY.COMMERCIAL_CONTENTS]: languageTexts.PROHIBITIONS_BEAUTY_COMMERCIAL_CONTENTS,
      [OPTIONS_PROHIBITIONS_BEAUTY.HDR]: languageTexts.PROHIBITIONS_BEAUTY_HDR,
      [OPTIONS_PROHIBITIONS_BEAUTY.DEADZONE]: languageTexts.PROHIBITIONS_BEAUTY_DEADZONE,
    },
    [GROUP_NAMES.REQUIREMENTS]: {
      [OPTIONS_REQUIREMENTS.IRONING]: languageTexts.REQUIREMENTS_IRONING,
      [OPTIONS_REQUIREMENTS.VIDEO_CLEAN]: languageTexts.REQUIREMENTS_VIDEO_CLEAN,
    },
    [GROUP_NAMES.HASH_TAG_LOCATION]: {
      [OPTIONS_HASH_TAG_LOCATION.POST]: languageTexts.HASH_TAG_LOCATION_POST,
      [OPTIONS_HASH_TAG_LOCATION.COMMENT]: languageTexts.HASH_TAG_LOCATION_COMMENT,
    },
    [GROUP_NAMES.ALLOW_ADVERTISEMENT_TAG]: {
      [OPTIONS_ALLOW_ADVERTISEMENT_TAG.ALLOW]: languageTexts.ALLOW_ADVERTISEMENT_TAG_ALLOW,
      [OPTIONS_ALLOW_ADVERTISEMENT_TAG.DISALLOW]: languageTexts.ALLOW_ADVERTISEMENT_TAG_DISALLOW,
    },
    [GROUP_NAMES.ALLOW_OTHER_AT_TAG]: {
      [OPTIONS_ALLOW_OTHER_AT_TAG.ALLOW]: languageTexts.ALLOW_OTHER_AT_TAG_ALLOW,
      [OPTIONS_ALLOW_OTHER_AT_TAG.DISALLOW]: languageTexts.ALLOW_OTHER_AT_TAG_DISALLOW,
    },
    [GROUP_NAMES.VIDEO_DURATION]: {
      [OPTIONS_VIDEO_DURATION.TWOWENTY]: languageTexts.VIDEO_DURATION_TWOWENTY,
      [OPTIONS_VIDEO_DURATION.THIRTY]: languageTexts.VIDEO_DURATION_THIRTY,
    },
    [GROUP_NAMES.PREFERRED_VIDEO_TYPE]: {
      [OPTIONS_PREFERRED_VIDEO_TYPE.EMOTIONAL]: languageTexts.PREFERRED_VIDEO_TYPE_EMOTIONAL,
      [OPTIONS_PREFERRED_VIDEO_TYPE.INFOMATIVE]: languageTexts.PREFERRED_VIDEO_TYPE_INFOMATIVE,
      [OPTIONS_PREFERRED_VIDEO_TYPE.VISITING]: languageTexts.PREFERRED_VIDEO_TYPE_VISITING,
      [OPTIONS_PREFERRED_VIDEO_TYPE.OY_VISITING]: languageTexts.PREFERRED_VIDEO_TYPE_OY_VISITING,
      [OPTIONS_PREFERRED_VIDEO_TYPE.OY_PRODUCT_ONLY]: languageTexts.PREFERRED_VIDEO_TYPE_OY_PRODUCT_ONLY,
    },
    [GROUP_NAMES.REQUIRE_PARTNERSHIP_CODE]: {
      [OPTIONS_REQUIRE_PARTNERSHIP_CODE.REQUIRED]: languageTexts.REQUIRE_PARTNERSHIP_CODE_REQUIRED,
      [OPTIONS_REQUIRE_PARTNERSHIP_CODE.NOT_REQUIRED]: languageTexts.REQUIRE_PARTNERSHIP_CODE_NOT_REQUIRED,
    },
  };

  // 단일 값만 있는 그룹들
  const SINGLE_GROUP_MAP = {
    [GROUP_NAMES.REELS_PRODUCT]: languageTexts.REELS_PRODUCT,
    [GROUP_NAMES.REELS_PRODUCT_PACKAGE]: languageTexts.REELS_PRODUCT_PACKAGE,
    [GROUP_NAMES.REELS_PRODUCT_TEXTURE]: languageTexts.REELS_PRODUCT_TEXTURE,
    [GROUP_NAMES.REELS_PRODUCT_COLOR]: languageTexts.REELS_PRODUCT_COLOR,
    [GROUP_NAMES.REELS_PRODUCT_TRY]: languageTexts.REELS_PRODUCT_TRY,
    [GROUP_NAMES.REELS_PRODUCT_BEFORE_AFTER]: languageTexts.REELS_PRODUCT_BEFORE_AFTER,
    [GROUP_NAMES.REELS_PRODUCT_SELFIE]: languageTexts.REELS_PRODUCT_SELFIE,
    [GROUP_NAMES.PHOTO_MODEL_FULL]: languageTexts.PHOTO_MODEL_FULL,
    [GROUP_NAMES.PHOTO_MODEL_HALF]: languageTexts.PHOTO_MODEL_HALF,
    [GROUP_NAMES.PHOTO_MODEL_CLOSEUP]: languageTexts.PHOTO_MODEL_CLOSEUP,
    [GROUP_NAMES.PHOTO_MODEL_WITHOUT_FACE]: languageTexts.PHOTO_MODEL_WITHOUT_FACE,
    [GROUP_NAMES.PHOTO_PRODUCT_FULL]: languageTexts.PHOTO_PRODUCT_FULL,
    [GROUP_NAMES.PHOTO_PRODUCT_CLOSEUP]: languageTexts.PHOTO_PRODUCT_CLOSEUP,
    [GROUP_NAMES.REELS_BEAUTY_PRODUCT_SELFIE]: languageTexts.REELS_BEAUTY_PRODUCT_SELFIE,
    [GROUP_NAMES.REELS_BEAUTY_PRODUCT_TRY]: languageTexts.REELS_BEAUTY_PRODUCT_TRY,
    [GROUP_NAMES.REELS_BEAUTY_PRODUCT_FULL]: languageTexts.REELS_BEAUTY_PRODUCT_FULL,
    [GROUP_NAMES.SUBTITLE_OPENING]: languageTexts.SUBTITLE_OPENING,
    [GROUP_NAMES.SUBTITLE_MIDDLE]: languageTexts.SUBTITLE_MIDDLE,
    [GROUP_NAMES.SUBTITLE_CLOSING]: languageTexts.SUBTITLE_CLOSING,
  };

  // 옵션이 있는 그룹인 경우
  if (groupName in OPTION_GROUP_MAP) {
    return OPTION_GROUP_MAP[groupName][value];
  }

  // 단일 값만 있는 그룹인 경우
  if (groupName in SINGLE_GROUP_MAP) {
    return SINGLE_GROUP_MAP[groupName];
  }

  return value || groupName;
};

const GUIDELINE_RULES = {
  OUTPUT_TYPES,
  TYPES,
  GROUP_NAMES,
  OPTIONS_PROHIBITIONS,
  OPTIONS_PROHIBITIONS_BEAUTY,
  OPTIONS_REQUIREMENTS,
  OPTIONS_HASH_TAG_LOCATION,
  OPTIONS_ALLOW_OTHER_AT_TAG,
  OPTIONS_ALLOW_ADVERTISEMENT_TAG,
  OPTIONS_VIDEO_DURATION,
  OPTIONS_PREFERRED_VIDEO_TYPE,
  RESERVED_FEEDBACK_TEXT,
  OPTIONS_REQUIRE_PARTNERSHIP_CODE,
  GetOptionTranslationMap,
};

export default GUIDELINE_RULES;
